import { useEffect, useState } from "react";

import { BASE_DOMAINS } from "../constants/constant";

function getSubdomain(hostname) {
    hostname = hostname.toLowerCase();

    for (const base of BASE_DOMAINS) {
        if (hostname === base) return null;

        if (hostname.endsWith("." + base)) {
            const sub = hostname.slice(0, -(base.length + 1));
            // return sub === "www" ? null : sub;
            let ss = sub === "www" ? null : sub;
            return {
                subdomain: ss,
                // subdomainUrl: (hostname == "localhost") ? `http://${ss}.${base}` : `https://${ss}.${base}`,
                // primaryUrl: (hostname == "localhost") ? `http://${base}` : `https://${base}`,
                subdomainUrl: `${window.location.protocol}//${ss}.${base}`,
                primaryUrl: `${window.location.protocol}//${base}`,
            }
        }
    }

    return null;
}

export function useSubdomain() {
    const [subdomain, setSubdomain] = useState(null);
    const [subdomainUrl, setSubdomainUrl] = useState(null);
    const [primaryUrl, setPrimaryUrl] = useState(null);

    useEffect(() => {
        const sub = getSubdomain(window.location.hostname);
        setSubdomain(sub?.subdomain);
        setSubdomainUrl(sub?.subdomainUrl);
        setPrimaryUrl(sub?.primaryUrl);
    }, []);



    return {
        subdomain,
        hasSubdomain: !!subdomain,
        subdomainUrl,
        primaryUrl
    };
}